import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const CursorRing = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  pointer-events: none;
  border-radius: 50%;
  mix-blend-mode: difference;
  transform-origin: 50% 50%;
`;

const CursorDot = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  pointer-events: none;
  border-radius: 50%;
  background: #000000;
  transform-origin: 50% 50%;
`;

const ringVariants = {
  default: {
    width: 32,
    height: 32,
    x: -16,
    y: -16,
    border: "1px solid rgba(0, 0, 0, 0.3)",
    backgroundColor: "transparent",
    opacity: 1,
    scale: 1,
  },
  text: {
    width: 80,
    height: 80,
    x: -40,
    y: -40,
    border: "1px solid rgba(0, 122, 255, 0.5)",
    backgroundColor: "rgba(0, 122, 255, 0.05)",
    scale: 1,
  },
  button: {
    width: 60,
    height: 60,
    x: -30,
    y: -30,
    border: "2px solid rgba(0, 122, 255, 0.8)",
    backgroundColor: "rgba(0, 122, 255, 0.1)",
    scale: 1,
  },
  link: {
    width: 48,
    height: 48,
    x: -24,
    y: -24,
    border: "1px solid rgba(0, 122, 255, 0.6)",
    backgroundColor: "rgba(0, 122, 255, 0.08)",
    scale: 1,
  },
};

const dotVariants = {
  default: {
    width: 6,
    height: 6,
    x: -3,
    y: -3,
    opacity: 1,
    scale: 1,
  },
  text: {
    width: 4,
    height: 4,
    x: -2,
    y: -2,
    opacity: 0.8,
    scale: 1,
  },
  button: {
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    opacity: 1,
    scale: 1,
  },
  link: {
    width: 6,
    height: 6,
    x: -3,
    y: -3,
    opacity: 0.9,
    scale: 1,
  },
};

const Cursor = ({ mousePosition, cursorVariant }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible || (!mousePosition.x && !mousePosition.y)) return null;

  return (
    <>
      <CursorRing
        variants={ringVariants}
        animate={cursorVariant}
        style={{
          translateX: mousePosition.x,
          translateY: mousePosition.y,
        }}
        transition={{
          type: "spring",
          damping: 25,
          stiffness: 200,
          mass: 0.3,
        }}
      />
      
      <CursorDot
        variants={dotVariants}
        animate={cursorVariant}
        style={{
          translateX: mousePosition.x,
          translateY: mousePosition.y,
        }}
        transition={{
          type: "spring",
          damping: 15,
          stiffness: 300,
          mass: 0.2,
        }}
      />
    </>
  );
};

export default Cursor; 